import { Author } from '../data/authors';
import { useLanguage } from '../contexts/LanguageContext';

const AuthorCard = ({ author }: { author: Author }) => {
  const { locale } = useLanguage();
  const displayName = author.name[locale] || author.name.en;
  const displayBio = author.bio[locale] || author.bio.en;
  const avatarAlt = author.avatar?.alt[locale] || author.avatar?.alt.en || displayName;

  return (
    <article className="author-card">
      {author.avatar ? (
        <div className="author-card__avatar">
          <img src={author.avatar.url} alt={avatarAlt} loading="lazy" />
        </div>
      ) : null}
      <div className="author-card__body">
        <h3>{displayName}</h3>
        {displayBio ? <p className="author-card__bio">{displayBio}</p> : null}
      </div>
    </article>
  );
};

export default AuthorCard;
